import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledInput = styled.input`
  background: #ffffff;
  flex: 7;
  display: inherit;
  height: 100%;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border: none;
  padding: 0 16px 0 16px;
  font-size: 1em;
  &:focus {
    outline: none;
  }
`;

const StyledBtn = styled.div`
  text-align: center;
  background-color: #ff8a80;
  color: #ffffff;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  display: inherit;
  height: 100%;
  flex: 2;
  align-items: center;
  cursor: pointer;
  font-family: 'Comfortaa', cursive;
`;

const StyledBtnText = styled.span`
  margin: 0 auto;
`;

const StyledInputConatiner = styled.div`
  display: inherit;
  margin: 0 auto;
  width: 100%;
  height: 60px;
  justify-content: center;
  box-shadow: 0px 6px 12px 3px rgba(171, 171, 171, 0.37);
  border-radius: 4px;
`;

const StyledContainer = styled.div`
  display: flex;
`;

export default class EmailInput extends React.Component {
  render() {
    return (
      <StyledContainer>
        <StyledInputConatiner>
          <StyledInput
            placeholder={this.props.placeholder}
            onChange={this.props.inputUpdateHandler}
          />
          <StyledBtn onClick={this.props.clickHandler}>
            {this.props.btnText}
          </StyledBtn>
        </StyledInputConatiner>
      </StyledContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EmailInput.js